import { render, staticRenderFns } from "./ModificacionCentroCosto.vue?vue&type=template&id=d1b0d352"
import script from "./ModificacionCentroCosto.vue?vue&type=script&lang=js"
export * from "./ModificacionCentroCosto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports